import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { Grid } from "semantic-ui-react";
import { selectBorderTransportMeanList } from "@EUForms/selectors";
import { useUpdateEffect } from "@hooks/useUpdateEffect";

const AirFreight = ({ saveData, updateData }) => {

  const airFreightPercent = useSelector((state) => state.transportReducer.countryInfo.airFreightPercent);
  const modeOfTransport = useSelector(selectBorderTransportMeanList)?.[0]?.modeOfTransport;
  
  useUpdateEffect(() => {
    if (modeOfTransport !== "4") {
      dispatch(updateData({ key: "countryInfo", data: { airFreightPercent: 100 } }))
      saveData({ "countryInfo": { airFreightPercent: 100 } })
    }
  }, [modeOfTransport])

  const dispatch = useDispatch()

  // const onChange=useCallback(({target:{value,name}})=>dispatch(updateData({[name]:value})),[updateData])
  // const onBlur=useCallback(({target:{value,name}})=>saveData({[name]:value}),[saveData])

  const onChange = useCallback(({ target: { value, name } }, data, otherFields = {}) => dispatch(updateData({ key: "countryInfo", data: { [name]: value, ...otherFields } })), [updateData])
  const onBlur = useCallback(({ target: { value, name } }, data, otherFields = {}) => saveData({ "countryInfo": { [name]: value || " ", ...otherFields } }), [saveData])


  return (
    <div className="grow self-end col formContainer">
      <Grid.Row>
        <Grid.Column>
          <InputField
            id="AirFreight"
            isLabel={false}
            name="airFreightPercent"
            type='number'
            label="AirFreight%"
            clearInput={false}
            value={airFreightPercent}
            isDisabled={true}
            onChange={onChange}
            onBlur={onBlur}
          />

        </Grid.Column>
      </Grid.Row>
    </div>

  )
}
export default React.memo(AirFreight)